import React, { useState } from "react";
import { Checkbox } from "@vds/checkboxes";
import { Modal, ModalBody, ModalFooter, ModalTitle } from "@vds/modals";

function NoRouterModal({
  onClick = () => { },
  onClose = () => { },
  opened = false,
}) {
  const [isChecked, setChecked] = useState(false);
  const [hasError, setHasError] = useState(false);

  function handlePrimary() {
    try {
      if (isChecked) {
        setChecked(false);
        setHasError(false);
        onClick();
      } else {
        setHasError(true);
      }
    } catch (e) {
      console.error(e);
    }
  }

  function handleClose() {
    try {
      setChecked(false);
      setHasError(false);
      onClose();
    } catch (e) {
      console.error(e);
    }
  }

  return (
    <Modal
      opened={opened}
      surface="light"
      disableOutsideClick={true}
      ariaLabel="NoRouterModal"
      onOpenedChange={(open) => {
        if (!open) {
          handleClose()
        }
      }}
    >
      <ModalTitle>
        Don't want to use a router?
      </ModalTitle>
      <ModalBody>
        <p>Please review the following information.</p>
        <p><b>All Fios TV Customers:</b></p>
        <p>If you choose not to use a router, you may not receive the full benefits of your Fios TV service.</p>
        <p>Not using a Verizon branded router can impact access to features like:</p>
        <ul>
          <li>Guide</li>
          <li>Video-on-Demand</li>
          <li>Pay-per-View</li>
        </ul>
        {opened !== "review-details" && (
          <Checkbox
            onChange={() => setChecked(!isChecked)}
            error={hasError}
            errorText="Check the box to confirm and continue."
            label="I understand that by not using a Verizon branded router, I may not receive the full benefits of my service."
          />
        )}
        {hasError && (
          <p>{hasError}</p>
        )}
      </ModalBody>
      <ModalFooter
        buttonData={opened === "review-details" ? {
          primary: {
            children: "Got it",
            onClick: (e) => handleClose(e),
          },
        } : {
          primary: {
            children: "Continue",
            onClick: (e) => handlePrimary(e),
          },
          close: {
            children: "Cancel",
            onClick: (e) => handleClose(e),
          },
        }}
      />
    </Modal>
  );
}

export default NoRouterModal;